import React from 'react'

function MobileAppPage() {
  return (
    <div>MobileAppPage</div>
  )
}

export default MobileAppPage